module.exports = __webpack_public_path__ + "fonts/2fe0100.woff";